import { motion } from "framer-motion";

export const SectionHeading = ({ kicker, title, align = "left", accent = "blue", testId }) => {
  const isAcid = accent === "acid";
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className={align === "center" ? "text-center" : ""}
    >
      <div
        className={`font-mono text-xs uppercase tracking-[0.3em] ${
          isAcid ? "text-[#B7FF2A]" : "text-[#1EA7FF]"
        }`}
      >
        // {kicker}
      </div>
      <h2 className="mt-2 font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-[0.04em] leading-[0.95]">
        {title}
      </h2>
      <div
        className={`mt-4 h-[3px] w-16 ${isAcid ? "bg-[#B7FF2A]" : "bg-[#1EA7FF]"} ${
          align === "center" ? "mx-auto" : ""
        }`}
      />
    </motion.div>
  );
};
